import {
  Ordonnance,
  OrdonnanceTemplate,
  Patient
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import {
  getItemId,
  getUserId,
  removeIds
} from "@/src/utils/utils";

import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { useState } from "react";

import {
  closeDrawer,
  openDrawer
} from "../../components/dialogs";

import { openPosologyCalculation } from "@/src/app/medicines/posologyCalculationsHook";
import { DayPicker } from "@/src/components/datePicker";

import { CompartmentCard } from "@/src/components/cards";
import { ListConstructor } from "@/src/components/fetchableLists";
import { CardType, FolderItem } from "@/src/data/allTypes";
import { USER } from "@/src/data/globalVariables";
import { isNurse } from "@/src/utils/utils";
import { generateTasks } from "../medicines/generateTasks";
import {
  openOrdonnanceMedicineForm
} from "../medicines/ordonnanceMedicineForm";
import { MedicinesAndTemplatesChoiceList } from "./ordonnancesCompartment";
import { TreatmentTimeline } from "./treatmentTimeline";

function HospitalisationTreatment({
  color,
  templates,
  patient,
  parent,
}: {
  color?: CardType;
  templates?: (OrdonnanceTemplate | null | undefined)[];
  patient: Patient;
  parent: FolderItem;
}) {
  const [reload, setReload] = useState(0);
  const [start, setStart] = useState(moment().format("YYYY-MM-DD"));
  const [end, setEnd] = useState(moment().add(1, "day").format("YYYY-MM-DD"));
  let [searchKey, setSearchKey] = useState("");
  let { data, isLoading, isError, error } = useQuery({
    queryKey: ["HospitalisationTreatment", searchKey, getItemId(patient), getItemId(parent), start, reload],
    queryFn: () =>
      apiFetch(
        "tasks",
        "loadMany",
        { parentId: getItemId(parent) },
        "Erreur lors du chargement des tâches"
      ),
  });

  async function openMedicineDialog() {
    await openDrawer({
      id: "medicinesAndTemplatesChoiceList",
      title: "Choisir un médicament",
      content: (
        <MedicinesAndTemplatesChoiceList
          showRenewButton={false}
          patient={patient}
          initialTemplates={templates}
          onSelect={async (medicine, template) => {
            if (template) {
              let ordonnance: Ordonnance = {
                creator: getUserId(),
                parent,
                patient,
                category: "hospital",
                ordonnanceMedicines: removeIds(template.ordonnanceMedicines),
              };

              await openPosologyCalculation({
                ordonnance,
                onConfirm: async () => {
                  for (let ordonnanceMedicine of ordonnance.ordonnanceMedicines) {
                    if (!ordonnanceMedicine) continue;
                    ordonnanceMedicine.tasks = generateTasks({
                      ordonnanceMedicine,
                      parent,
                      patient,
                    });
                    console.log("taaaasks", ordonnanceMedicine.tasks);
                  }
                  await apiFetch("ordonnances", "addOne", {
                    ordonnance,
                  });
                  setReload(reload + 1);
                  closeDrawer("medicinesAndTemplatesChoiceList");
                  closeDrawer("ordonnanceTemplateChoiceDrawer");
                },
              });
            }

            if (medicine) {
              await openOrdonnanceMedicineForm({
                ordonnanceMedicine: null,
                medicine,
                patient,
                parent,
                onConfirm: (ordonnance) => {
                  closeDrawer("medicineChoiceDrawer");
                  closeDrawer("medicinesAndTemplatesChoiceList");
                  setReload(reload + 1);
                },
              });
            }
          }}
        />
      ),
    });
  }

  let child = (
    <div>
      <div className="c3 mc1 center mbottom10">
        <div></div>
        <DayPicker
          value={start}
          onChange={async (newValue) => {
            setStart(moment(newValue).format("YYYY-MM-DD"));
            setEnd(moment(newValue).add(1, "day").format("YYYY-MM-DD"));
          }}
        ></DayPicker>
        <div></div>
      </div>

      <div className="fade" key={`calendarTreatment${start}`}>
        <TreatmentTimeline
          tasks={data || []}
          start={start}
          end={end}
          patient={patient}
          parent={parent}
          onChange={() => {
            setReload(reload + 1);
          }}
        ></TreatmentTimeline>
      </div>
    </div>
  );
  
  return (
    <CompartmentCard
      title="Traitement"
      color={color || "purple"}
      onClick={
        isNurse(USER?.get())
          ? undefined
          : () => {
              openMedicineDialog();
            }
      }
    >
      <ListConstructor
        isLoading={isLoading}
        isError={isError}
        error={error}
        data={data}
        // emptyChild={false}
        emptyChild={child}
      >
        {child}
      </ListConstructor>
    </CompartmentCard>
  );
}

export { HospitalisationTreatment };
